
import Footer from "../components/footer";
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import { useNavigate } from "react-router-dom";

const OrderList = () => {
    
    const navigate = useNavigate();
    const [dataOrderList, setDataOrderList] = useState([]);

        // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderListAll', setDataOrderList);

    }, [dataOrderList]);

    const columns = [
        {
            name: "Order No",
            selector: row => row.id,
            width: "80px"
        },
        {
            name: "Buyer",
            selector: (row) => row.buyerName,
            width: "150px"
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            width: "150px"
        },  
        {
            name: "Payment Mode",
            selector: (row) => row.paymentMode,
            width: "150px"
        },
        {
            name: "Payment Status",
            selector: (row) => row.paymentStatus,
            width: "120px"
        },
        {
            name: "Order Status",
            selector: (row) => row.orderStatus,
            width: "110px"
        }, 
        {
            name: "Order Date",
            selector: (row) => new Date(row.createdOn).toLocaleDateString('en-GB',{day: 'numeric', month: 'short', year: 'numeric'}),
            width: "110px"
        },
        {
            name: "Action",
            cell: (row) => <>
            
            <button style={{ width: "130px" }} className={`btn m-1 btn-primary tp`} onClick={(event) => OnViewClick(event, row.id)}><span className="tptitle">Order View</span><i className="bi bi-eye-fill"></i>&nbsp;<small>View Details</small></button>
                </>
        },
    ];

    const OnViewClick = async(event, id)=>{
        event.preventDefault(); // Prevents the default behavior of the link
    
        // Determine the path based on the userType_id
        const path = `/orderDetails/${id}`;        
        // Navigate to the determined path
        navigate(path);
    }

    
    
    
    return (
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Order List' icon='bi bi-cart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Order List</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataOrderList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default OrderList;